export const checkReduceMotion = (): boolean => {
	if (typeof window !== 'object') {
		return true;
	}
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
